import React from "react";
import { genURL, gengetURLTEST } from '../_getjson';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import PopUpSELSTKMOVEREQSub from './PopUpSELSTKMOVEREQSub';
import axios from 'axios'
import { parseJwt } from '../parseJWT';
// var token = localStorage.getItem("Token");  
// const company = localStorage.getItem("company"); 
//require( './PopUpARInvDebt.css');
require('./../_css/PopUpOther.css');

export default class PopUpOther extends React.Component {

    constructor(props) {
        super(props);
        this.P_DOCNO = React.createRef();
        this.Search = React.createRef();
        this.state = {
            SELSTKMOVEREQsub: false,
            type: this.props.type,
            col: [],
            rows: [],
            Htext: "",
            SHtype: 3,
            P_DOCNO: "",
            casschkbox: "far fa-square",
            casschkboxs: false,
            ckbox_length: 0,
        }
    }
    chkdata = (data) => {
        var redata = "";
        if (data) {
            redata = data;
        }
        return redata;
    }
    //--------------------------------โชว์ PopUpARPaybillsub
    SetPopup3 = (data) => {
        this.setState({ PopUpTYpe5: data });
        this.setState({ SELSTKMOVEREQsub: !this.state.SELSTKMOVEREQsub });
    }
    //รับค่าหน้า PopUpARPaybillsub แล้วส่งค่ากลับหน้าหลัก
    Get_PopUpSELSTKMOVEREQSub = (data) => {
        this.props.Get_SELSTKMOVEREQ(data);
        this.setState({ SELSTKMOVEREQSub: !this.state.SELSTKMOVEREQSub });
    }

    PopUpSELSTKMOVEREQSub = (data) => {
        this.setState({ SELSTKMOVEREQSub: !this.state.SELSTKMOVEREQSub });
    }
    //-------------------------- 
    //กดค้นหา
    Get_Data = async (event) => {
        console.log(event);
        var dataArray = [];
        var Url = "";
        var DOCNO
        if (event === "SELSTKMOVEREQ") {
            DOCNO = this.Search.current.value;
            Url = "CSSTKMOVEREQ/Getdataformainpupup?text=" + DOCNO;
        } else if (event === "SELSTKMOVEREQ1") {
            Url = "CSSTKMOVEREQ/Getdataformainpupup?top=100"
        } else if (event.key === "Enter") {
            DOCNO = (event.target.value);
            Url = "CSSTKMOVEREQ/Getdataformainpupup?text=" + DOCNO;
        } else {
            return //--------------- Exit เมื่อไม่เข้าเงือนไขไหนเลย
        }
        console.log(genURL(Url));
        await axios.get(genURL(Url), { timeout: 60000 }).then(res => {
            if (res.data.length > 0) {
                for (let i = 0; i < res.data.length; i++) {
                    dataArray[i] = {
                        number: i + 1,
                        Col1: res.data[i].DOCNO,
                        Col2: this.GetformatTimestamp(res.data[i].DOCDATE),
                        Col3: res.data[i].REMARK,
                        SB: "0"

                    }
                }
                this.setState({ col: dataArray });
                this.GetSearchTimeout();
            } else {
                dataArray = [];
                this.setState({ col: dataArray });
                this.GetSearchTimeout();
            }
        });
    }

    GetSearchTimeout = () => {
        this.setState({ rows: this.state.col });
    }
    GetformatTimestamp = (date) => {
        if (date) {
            var myDate = new Date(date);
            var date = myDate.getDate(); if (myDate.getDate() < 10) { date = "0" + myDate.getDate(); }
            var month = (myDate.getMonth() + 1); if ((myDate.getMonth() + 1) < 10) { month = "0" + (myDate.getMonth() + 1); }
            var year = myDate.getFullYear() + 543;
            return date + "/" + month + "/" + year;
        } else {
            return "";
        }
    }
    componentDidMount() {
        //โหลดหน้าครั้งแรกเรียก API โชว์ข้อมูล
        let SITECODESTR = parseJwt(localStorage.getItem('Token'));
        var dataArray = [];
        switch (this.props.type) {
            case "SELSTKMOVEREQ":
                this.setState({ sh_Deposit: true });
                var Url = "CSSTKMOVEREQ/Getdataformainpupup?top=100";
                console.log(genURL(Url));
                axios.get(genURL(Url), { timeout: 60000 }).then(res => {
                    var j = 0;
                    if (res.data.length >= 1) {
                        for (let i = 0; i < res.data.length; i++) {
                            // if(res.data[i].SITECODE===SITECODESTR.User.SITECODE){
                            dataArray[j] = {
                                number: j + 1,
                                Col1: res.data[i].DOCNO,
                                Col2: this.GetformatTimestamp(res.data[i].DOCDATE),
                                Col3: res.data[i].REMARK,
                                SB: "0"
                            }
                            j++;
                            //}
                        }
                        this.setState({ col: dataArray });
                        this.GetSearchTimeout();
                    } else {
                        dataArray = [];
                        this.setState({ col: dataArray });
                        this.GetSearchTimeout();
                    }
                }).catch(error => {
                    console.log(error);
                });
                this.setState({ col: dataArray, Htext: "ค้นหาใบขอโอน" });
                break;
        }
    }
    //onClick checkbox 
    cellcheckbok = (cell, row, enumObject, rowIndex) => {
        var btn = this.state.rows[rowIndex].SB;
        var btnShow;
        switch (btn) {
            case "0": btnShow = <span>
                <i className="far fa-square " onClick={this.Update_Status.bind(null, rowIndex, "1")}> </i>
            </span>;
                break;
            case "1": btnShow = <span>
                <i className="far fa-check-square" onClick={this.Update_Status.bind(null, rowIndex, "0")}>  </i>
            </span>;
                break;
            default: btnShow = <span><i className=""></i></span>;
        }
        return (<div>{btnShow}</div>)
    }
    //เปลี่ยนสถานะ checkbox 
    Update_Status = (Row, Status) => {
        if (Status === "ALL") {
            if (this.state.casschkboxs === false) {
                //กด checkbox เลือกทั้งหมด
                this.setState({ casschkbox: "far fa-check-square" });
                this.setState({ casschkboxs: !this.state.casschkboxs });
                var dataArray = this.state.rows;
                for (var i = 0; i < this.state.rows.length && this.state.rows[i].Col1; i++) {
                    dataArray[i].SB = "1";
                }
                this.setState({ row: dataArray });
            } else {
                //กด checkbox ไม่เลือก
                this.setState({ casschkbox: "far fa-square" });
                this.setState({ casschkboxs: !this.state.casschkboxs });
                var dataArray = this.state.rows;
                for (var i = 0; i < this.state.rows.length && this.state.rows[i].Col1; i++) {
                    dataArray[i].SB = "0";
                }
                this.setState({ row: dataArray });
            }
        } else {
            //เปลี่ยนสถานะไม่มีการเลือกทั้งหมด (checkbox หัวตาราง) เมื่อมีการติ๊กรายการใดรายการหนึ่งออก
            if (Status === "0") {
                this.setState({ casschkbox: "far fa-square" });
                this.setState({ casschkboxs: false });
            }
            //เปลี่ยนสถานะ เลือก/ไม่เลือก (checkbox แต่ละแถว)
            var dataArray = this.state.rows;
            dataArray[Row].SB = Status;
            this.setState({ rows: dataArray });
            //เปลี่ยนสถานะเลือกทั้งหมด (checkbox หัวตาราง) เมื่อเลือกทุกรายการ
            var sb_length = 0;
            for (var i = 0; i < this.state.rows.length && this.state.rows[i].Col1; i++) {
                if (this.state.rows[i].SB === 1) { sb_length = sb_length + 1; }
            }
            if (sb_length === this.state.rows.length) {
                this.setState({ casschkbox: "far fa-check-square" });
                this.setState({ casschkboxs: true });
            }
        }
    }
    onSelectRow = (data, col, id) => {
        //ส่งกลับเมื่อมีการคลิกเลือกข้อมูล
        if (col > 1) {
            var dataArray = this.state.rows;
            dataArray[id].SB = "1";
            this.setState({ rows: dataArray });
            var sb_length = 0;
            var docno = "";
            for (var i = 0; i < this.state.rows.length && this.state.rows[i].Col1; i++) {
                if (this.state.rows[i].SB === "1") {
                    console.log("test");
                    sb_length = sb_length + 1;
                    if (docno === "") { //รอบแรก ยังไม่ใส่ |
                        docno += this.state.rows[i].Col1;
                    } else {
                        docno += "|" + this.state.rows[i].Col1;
                    }
                }
            }
            console.log(docno)
            this.P_DOCNO.current.value = docno
            setTimeout(() => {
                this.setState({ PopUpTYpe5: data });
                this.setState({ SELSTKMOVEREQSub: !this.state.SELSTKMOVEREQSub });
            }, 0);
        }
    }
    onSubmit = () => {
        var sb_length = 0;
        var docno = "";
        for (var i = 0; i < this.state.rows.length && this.state.rows[i].Col1; i++) {
            if (this.state.rows[i].SB === "1") {
                console.log("test");
                sb_length = sb_length + 1;
                if (docno === "") { //รอบแรก ยังไม่ใส่ |
                    docno += this.state.rows[i].Col1;
                } else {
                    docno += "|" + this.state.rows[i].Col1;
                }
            }
        }
        console.log(docno)
        this.P_DOCNO.current.value = docno
        if (docno !== "") {
            setTimeout(() => {
                /* this.setState({ PopUpTYpe5: data }); */
                this.setState({ SELSTKMOVEREQSub: !this.state.SELSTKMOVEREQSub });
            }, 0);
        }
    };

    render() {
        return (
            <div className='popup'>
                {this.state.SELSTKMOVEREQSub ? <PopUpSELSTKMOVEREQSub closePopup={this.PopUpSELSTKMOVEREQSub} Get_PopUpSELSTKMOVEREQSub={this.Get_PopUpSELSTKMOVEREQSub} type={this.state.PopUpTYpe5} Data={this.state.valuePopup5} ARCODE={this.props.ARCODE} P_DOCNO={this.P_DOCNO.current.value} from="PopUpSelSaleRef3" /> : null}
                <div className='popup_inner'>
                    {/* _arinvdebt divBox */}
                    {this.props.Data}
                    <div className="PopUpOtherDivH" align="left">
                        {/* <div className="PopUpOtherDivH1"><i className="fas fa-search">fas fa-at {this.state.Htext} </i></div> */}
                        {/* <div className="PopUpOtherDivH2"><i className="fas fa-times" onClick={this.props.closePopup}></i></div> */}
                    </div>
                    <div className="panel-body divTable" align="right" >
                        <input type="hidden" className="form-control " ref={this.P_DOCNO} />
                        <div className="form-group input-group col-xs-12 col-sm-6 col-md-6 col-lg-6"  >
                            <input type="hidden" className="form-control " ref="P_DOCNO" />
                            <input id="id1" type="text" className="form-control" ref={this.Search} onKeyPress={this.Get_Data.bind(null)} placeholder="กรอกเลขที่เอกสารหรือหมายเหตุ" />
                            <span id="iconsearch" className="input-group-addon icon"><i className="fas fa-search" onClick={() => { this.Get_Data("SELSTKMOVEREQ") }} ></i></span>
                            <span className="input-group-addon txt-img icon"> <i className="fas fa-sync-alt" onClick={() => { this.Get_Data("SELSTKMOVEREQ1") }}></i></span>
                        </div >
                        <div style={{ marginTop: "10px" }}>
                            <BootstrapTable
                                data={this.state.rows}
                                options={{
                                    onRowClick: this.onSelectRow,
                                    noDataText: "ไม่พบข้อมูลที่ค้นหา",
                                }}
                                height="500"
                                hover condensed  >
                                <TableHeaderColumn columnClassName="columnAll columnNumber" className="columnNumber" dataAlign="center" width="5%" dataField='number' isKey> </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="5%" dataField='SB' editable={false} dataAlign="center" dataFormat={this.cellcheckbok.bind(this)} > <div onClick={this.Update_Status.bind(null, "", "ALL")} > <i style={{ fontSize: '20px' }} className={this.state.casschkbox}> </i> </div></TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="25%" dataField='Col1' > ใบขอโอน </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="25%" dataField='Col2' > วันที่โอน </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="40%" dataField='Col3' > หมายเหตุ </TableHeaderColumn>
                            </BootstrapTable>
                        </div>
                        <button className="PUSDbtn" onClick={this.onSubmit}>
                            <i className="fas fa-check"> ตกลง </i>
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}